/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import ScrollMenu from "react-horizontal-scrolling-menu";

// import { loadProgressBar } from "axios-progress-bar";
// import queryString from "query-string";

// import ContentItemVod from "../../components/ContentItemVod";
// import moment from "moment";
import ContentItem from '../../components/ContentItem';
import TagSearchBoxSame from './TagSearchBoxSame';
//import InfiniteScroll from 'react-infinite-scroll-component';
//import PerfectScrollbar from 'react-perfect-scrollbar'

//import TagSameCode from './TagSameCode';
//import TagGenreCode from './TagGenreCode';
//import TagTagCode from './TagTagCode'
//import TagViewCode from './TagViewCode';
//import TagMemberShipCode from './TagMemberShipCode';
//import TagSearchBanner from './TagSearchBanner'

//import TagSearchBox from './TagSearchBox';
//import ThemeRolling from './ThemeRolling'

//import ProgressContainer from '../containers/ProgressContainer'

class TagSearchMainSame extends PureComponent {
  state = {
    sort: 'rank',
  };

  componentDidMount = () => {
    this._getData();
  };

  _getData = async () => {
    const result = await this._getDateApi();
    const intReturn = result.data[0].intReturn;
    const sameCode = result.data[0].sameCode;
    const contentList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        contentList,
        sameCode,
      });
    }
  };
  _getDateApi = () => {
    const { apiUrl, loginId } = this.props;

    return axios(apiUrl + '/sameTime?userid=' + loginId)
      .then((response) => response)
      .catch((error) => {
        console.log('error...');
      });
  };

  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <ContentItem
          key={index}
          contentSerial={item.contentSerial}
          title={item.title}
          genreName={item.genreName}
          img={item.img}
          overImg={item.overImg}
          restrictionCode={item.restrictionCode}
          opening={item.opening}
          director={item.director}
          contentSysnopsis={item.contentSysnopsis}
          dRank={item.dRank}
          viewCnt={item.viewCnt}
          wishFlag={item.wishFlag}
          contentPartSerial={item.contentPartSerial}
          num={index + 1}
          onEndItemSlide={this._onEndItemSlide}
          subTitle={item.subTitle}
        />
      );
    });

    return list;
  };

  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    setTimelineWeek(true);
  };
  _renderBox = () => {
    const { contentList } = this.state;
    //console.log(con)

    let temp = [];

    for (let i = 0; i < contentList.length; i = i + 6) {
      temp.push(
        <TagSearchBoxSame
          searchList={contentList.filter((item, index) => {
            return index >= i && index < i + 6;
          })}
          key={i}
        />
      );
    }

    const list = temp.map((item, index) => {
      return item;
    });

    return list;
  };
  _sort = (sort) => {
    const { contentList } = this.state;

    if (sort === 'rank') {
      contentList.sort(function (a, b) {
        return a.rank < b.rank ? -1 : a.rank > b.rank ? 1 : 0;
      });
    } else {
      contentList.sort(function (a, b) {
        return a.weekNo < b.weekNo
          ? -1
          : a.weekNo > b.weekNo
          ? 1
          : 0 || a.weekTime < b.weekTime
          ? -1
          : a.weekTime > b.weekTime
          ? 1
          : 0;
      });
    }

    this.setState({
      sort,
    });
  };

  _toggleSort = (num) => {
    const { contentPartList } = this.state;

    if (num === 0) {
      contentPartList.sort(function (a, b) {
        return a.part > b.part ? -1 : a.part < b.part ? 1 : 0;
      });
    } else {
      contentPartList.sort(function (a, b) {
        return a.part < b.part ? -1 : a.part > b.part ? 1 : 0;
      });
    }

    //console.log(contentPartList)
    this.setState({
      sort: num,
      contentPartList,
    });
  };
  _allShow = () => {
    const { allShow } = this.props.childProps;
    allShow();
  };
  render() {
    const { contentList, sort, sameCode } = this.state;
    // const { allShow } = this.props.childProps;
    return (
      <Fragment>
        <div className="vod_tit">
          <h2>
            {sameCode === undefined || sameCode === null || sameCode === ''
              ? null
              : sameCode.toString().substr(0, 4) +
                '.' +
                sameCode.toString().substr(4, 2)}{' '}
            한일동시방영작
          </h2>
          {/* <div className="tab_menu">
            <button
              type="button"
              className={sort === 'rank' ? 'w107 active' : 'w107'}
              onClick={() => this._sort('rank')}
            >
              <b>인기순</b>
            </button>
            <button
              type="button"
              className={sort === 'onair' ? 'w107 active' : 'w107'}
              onClick={() => this._sort('onair')}
            >
              <b>방영순</b>
            </button>
          </div> */}
          <div className="link">
            {/*<a onClick={this._timeTable} style={{ cursor: 'pointer'}}>신작 시간표 <span className="arrow"></span></a>*/}
            <a onClick={this._allShow} style={{ cursor: 'pointer' }}>
              전체작품 보기 <span className="arrow"></span>
            </a>
          </div>
        </div>

        <div className="vod_vod_list new_list">
          <div className="main_list_goup2">
            {contentList ? this._renderBox() : null}

            <div className="clear"></div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(TagSearchMainSame));
